import React from 'react';
import { language, setLanguage } from './locale';
export default function LanguageControl() {
  return <nav className="lab-language-control" aria-label={language === 'zh' ? '语言' : 'Language'}>
    <button type="button" lang="zh-CN" aria-pressed={language === 'zh'} onClick={() => setLanguage('zh')}>中文</button>
    <span aria-hidden="true">/</span>
    <button type="button" lang="en" aria-pressed={language === 'en'} onClick={() => setLanguage('en')}>EN</button>
    <button type="button" onClick={() => setLanguage('auto')}>{language === 'zh' ? '自动' : 'Auto'}</button>
  </nav>;
}
